(function () {
  const STORAGE_KEY = 'crysalidas_age_verified_session';
  let verifiedThisPage = false;

  function hasVerifiedAge() {
    if (verifiedThisPage) return true;
    try {
      return window.sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (_error) {
      return false;
    }
  }

  function rememberVerification() {
    verifiedThisPage = true;
    document.documentElement.classList.add('crysalidas-age-verified');
    try {
      window.sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (_error) {
      // The gate still closes for this page if storage is unavailable.
    }
  }

  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((element) => !element.hasAttribute('hidden') && element.getAttribute('aria-hidden') !== 'true');
  }

  function initAgeGate(gate) {
    if (!(gate instanceof HTMLElement) || gate.dataset.crysalidasInitialized === 'true') return;
    gate.dataset.crysalidasInitialized = 'true';

    if (hasVerifiedAge()) {
      gate.remove();
      return;
    }

    const previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    const inertState = [];
    const acceptButton = gate.querySelector('[data-crysalidas-age-accept]');

    document.body.appendChild(gate);
    document.documentElement.classList.add('crysalidas-age-lock');

    for (const sibling of Array.from(document.body.children)) {
      if (!(sibling instanceof HTMLElement) || sibling === gate) continue;
      inertState.push({ element: sibling, wasInert: sibling.inert });
      sibling.inert = true;
    }

    function handleKeydown(event) {
      if (event.key !== 'Tab') return;

      const focusable = getFocusableElements(gate);
      if (focusable.length === 0) {
        event.preventDefault();
        gate.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function closeGate() {
      rememberVerification();
      gate.removeEventListener('keydown', handleKeydown);
      for (const entry of inertState) entry.element.inert = entry.wasInert;
      document.documentElement.classList.remove('crysalidas-age-lock');
      gate.remove();

      if (
        previousFocus?.isConnected &&
        previousFocus !== document.body &&
        previousFocus !== document.documentElement
      ) {
        previousFocus.focus();
        return;
      }

      const main = document.getElementById('MainContent');
      if (main instanceof HTMLElement) {
        const hadTabindex = main.hasAttribute('tabindex');
        if (!hadTabindex) main.setAttribute('tabindex', '-1');
        main.focus();
        if (!hadTabindex) main.addEventListener('blur', () => main.removeAttribute('tabindex'), { once: true });
      }
    }

    gate.addEventListener('keydown', handleKeydown);
    acceptButton?.addEventListener('click', closeGate, { once: true });
    window.requestAnimationFrame(() => {
      if (acceptButton instanceof HTMLElement) acceptButton.focus();
    });
  }

  function initAllAgeGates(root) {
    if (root instanceof HTMLElement && root.matches('[data-crysalidas-age-gate]')) initAgeGate(root);
    root.querySelectorAll?.('[data-crysalidas-age-gate]').forEach(initAgeGate);
  }

  function start() {
    initAllAgeGates(document);
    document.addEventListener('shopify:section:load', (event) => initAllAgeGates(event.target));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
